import useAuth from "./hooks/useAuth";
import { useState } from "react";
import CheckUserSentencesSnapshot from "./CheckUserSentencesSnapshot";
import CheckUserSentencesDynamic from "./CheckUserSentencesDynamic";
import CheckUserSentencesIntensity from "./CheckUserSentencesIntensity";
import PronunciationTrendsDisplay from "./PronunciationTrendsDisplay";

const CheckUserSentences = ({ language, date, checkuser, representation }) => {
    const { auth } = useAuth();

    return (
        <div className="w-full">
            {representation === 'Snapshot' ? (
                <CheckUserSentencesSnapshot 
                    checkuser={checkuser} 
                    language={language} 
                    date={date} 
                />
            ) : representation === 'Dynamic' ? (
                <CheckUserSentencesDynamic 
                    checkuser={checkuser} 
                    language={language} 
                    date={date} 
                />
            ) : representation === 'Intensity' ? (
                <CheckUserSentencesIntensity 
                    checkuser={checkuser} 
                    language={language} 
                    date={date} 
                />
            ) : representation === 'Trends' ? (
                <PronunciationTrendsDisplay 
                    language={language} 
                    username={checkuser} 
                />
            ) : null}
        </div>
    );
}

export default CheckUserSentences;